/**
 * RTK Query / fetchBaseQuery error from mutation `.unwrap()` — extract API `detail` when present.
 */
export function getFetchErrorDetail(error: unknown): string | undefined {
  if (typeof error !== 'object' || error === null) return undefined;
  const e = error as { data?: unknown; message?: string };
  const { data } = e;
  if (typeof data === 'object' && data !== null && 'detail' in data) {
    const d = (data as { detail: unknown }).detail;
    if (typeof d === 'string') return d;
    if (Array.isArray(d)) return d.map(String).join(' ');
  }
  if (typeof e.message === 'string' && e.message !== 'Rejected') {
    return e.message;
  }
  return undefined;
}
